import { factory, getResponseCamelization } from '@repo-level/core-front';
import type { CMSApiBase } from 'api/cms/base';
import { buildCmsUrl, getResponseCMS } from 'api/cms/base';
import type { IFAQ, IHowToParticipate } from 'api/cms/cloverGoldPromo';

export interface ICMSHeadlinePromo extends CMSApiBase {
  howToParticipate: IHowToParticipate[];
  faq: IFAQ[];
}

export const headlinePromo = factory(
  (r) => (lang: string) =>
    r<ICMSHeadlinePromo>(
      'get',
      buildCmsUrl({
        path: 'headline-promo',
        lang,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);
